import { render, staticRenderFns } from "./Patients.html?vue&type=template&id=537b3323&external"
import script from "./Patients.js?vue&type=script&lang=js&external"
export * from "./Patients.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports